var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDevelopment01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#191919;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#191919;stroke-width:6;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#E5CF00;stroke-width:6;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#E5CF00;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#D6D6D6;stroke-width:7;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#D30F0F;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#191919;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:url(#SVGID_1_);}\n\t.st8{opacity:0.22;}\n\t.st9{fill:#FFFFFF;stroke:#282828;stroke-width:20;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#282828;stroke-width:20;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#282828;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{opacity:0.45;fill:none;stroke:#A3A3A3;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M624.57,778.76l287.75,0.15c27.56,0,49.9-22.34,49.9-49.9V382.49c0,0-169.41,56.47-276.71-70.02 c0,0,200.57-97.64,283.58,31.12c0,0,86.87-135.02,286.77-28.86c0,0-67.76,112.94-263.15,67.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M962.18,716.08v19.28c0,23.97,19.43,43.41,43.41,43.41h289.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M933.51,555.49c0,0-65.51-46.31-150.21,0c0,0,48.56,56.47,150.21,35.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M990.54,555.61c0,0,65.51-46.31,150.21,0c0,0-48.56,56.47-150.21,35.01"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment01);
export default __webpack_public_path__ + "static/media/Development-01.4566f89d5327daf491046c38f931372a.svg";
export { ForwardRef as ReactComponent };